import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_SubstituteMaintenance } from "../shared/data.service";
import { SubHistoryDetailsComponent } from "./sub-history-details/sub-history-details.component";
import * as moment from "moment";

@Component({
	selector: "caass-sub-history-table",
	templateUrl: "./sub-history-table.component.html",
	styleUrls: ["./sub-history-table.component.css"],
})
export class SubHistoryTableComponent implements OnInit {
	constructor(private userService: UserService, private SubstituteHistoryService: DataService_SubstituteMaintenance, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSubstitution();
	}

	ngOnChanges() {
		this.loadSubstitution();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() PersonID: any;

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSubstitution: any;
	lstSubstitution: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PersonName", header: "Subbing For" },
		{ field: "StartDateDesc", header: "Start Date" },
		{ field: "EndDateDesc", header: "End Date" },
		{
			field: "ClassAttendanceRecordCount",
			header: "Class Attendance Records",
		},
		{ field: "ClassAttendanceClasses", header: "Classes" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSubstitution() {
		if (this.PersonID == undefined || this.PersonID <= 0) {
			return;
		}

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;

		var result = this.SubstituteHistoryService.SubHistoryTableSelectList(this.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstSubstitution = response;

				//Load Data Filter Lists

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSubstitution();
	}

	//Custom Button Methods
	onViewSubHistory() {
		this.errorMessage = "";

		if (this.SelectedSubstitution == undefined) {
			this.errorMessage = "Select a substitution to view its details";
			return;
		}

		let popup_SizeInt = window.innerWidth - 80;
		let popup_Size = popup_SizeInt.toString() + "px";

		var ref = this.dialogService.open(SubHistoryDetailsComponent, {
			header: "View Details",
			width: popup_Size,
			data: {
				//INSERT Custom Data here
				SubstitutionID: this.SelectedSubstitution.SubstitutionID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				// this.loadSubstitution();
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSubstitution = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSubstitution = null;
	}
	onRowDblClick(Substitution) {
		this.SelectedSubstitution = Substitution;
		this.onViewSubHistory();
	}
	////////////////////////////////////////////
}
